// Notification sound utility
export const playNotificationSound = () => {
  try {
    // Try to play the notification sound
    const audio = new Audio('/notification-sound.mp3');
    audio.volume = 0.5; // Set volume to 50%
    
    // Add fallback for browsers that don't support audio
    audio.addEventListener('error', () => {
      console.log('Notification sound file not found, using fallback');
      // Create a simple beep sound using Web Audio API
      createBeepSound();
    });
    
    audio.play().catch(err => {
      console.log('Audio play failed, using fallback:', err);
      createBeepSound();
    });
  } catch (error) {
    console.log('Error playing notification sound:', error);
    createBeepSound();
  }
};

// Fallback beep sound using Web Audio API
const createBeepSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.frequency.value = 800; // 800Hz tone
    oscillator.type = 'sine';
    
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
    
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);
  } catch (error) {
    console.log('Fallback beep sound failed:', error);
  }
}; 